export var ADDON_ID = "storybook/html";
export var PANEL_ID = "".concat(ADDON_ID, "/panel");
export var PARAM_KEY = "html";
export var EVENTS = {
  CODE_UPDATE: "".concat(ADDON_ID, "/codeUpdate")
};